/* Toggle existing Shopify navigation submenus without disrupting main menu. */
(function(){
  var buttons=document.querySelectorAll('.bs-menu-expand');
  if(!buttons.length)return;
  buttons.forEach(function(button){
    button.addEventListener('click',function(event){
      event.stopPropagation();
      var parent=button.closest('.bs-menu-item');
      if(!parent)return;
      var open=parent.classList.toggle('is-open');
      button.setAttribute('aria-expanded',open?'true':'false');
      if(!open && window.matchMedia('(min-width: 901px)').matches) button.blur();
    });
  });
  document.addEventListener('click',function(event){
    buttons.forEach(function(button){
      var parent=button.closest('.bs-menu-item');
      if(parent&&!parent.contains(event.target)){parent.classList.remove('is-open');button.setAttribute('aria-expanded','false');}
    });
  });
  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    buttons.forEach(function(button){
      var parent=button.closest('.bs-menu-item');
      if(parent&&parent.classList.contains('is-open')){parent.classList.remove('is-open');button.setAttribute('aria-expanded','false');button.blur();}
    });
  });
})();
